import { z } from 'zod';
import { defineEndpoint } from '../define';
import { GitCommitSchema } from '../release-products/git-commits';

/**
 * The release's pinned commit (full SHA, message, committer date) for anyone
 * who can view the release; null before a commit is pinned.
 */
export const getReleaseCommit = defineEndpoint({
  method: 'GET',
  path: '/v1/releases/:releaseId/commit',
  params: z.object({ releaseId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: GitCommitSchema.nullable() }),
});
